import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import useNotificationHub from '../../hooks/useNotificationHub';
// import useAuth from '@/hooks/useAuth';
// import statsigClientInstance from '@/utils/statsig';
// import { StatsigProvider } from '@statsig/react-bindings';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64; // 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(5),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  }
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem('sidebar_collapsed') === 'true'
  );
  useNotificationHub();

  const handleToggleCollapse = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('sidebar_collapsed', String(next));
      return next;
    });
  };
  // const { user } = useAuth();
  // const client = statsigClientInstance(user);

  return (
    <RootStyle>
      {/* <StatsigProvider client={client}> */}
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} isCollapsed={isCollapsed} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
      {/* </StatsigProvider> */}
    </RootStyle>
  );
}
